<template>
  <v-row>
    <v-col
      v-for="(student, index) in children"
      :key="index"
      cols="12"
      xs="12"
      sm="6"
      md="4"
      lg="3"
    >
      <ScheduleCard :student="student" />
    </v-col>
    <ProgressCircular v-if="isLoading" />
  </v-row>
</template>

<script>
import ScheduleCard from "@/views/profile/ScheduleCard.vue";
import { mapActions, mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import { showToast } from "@/utils/toast";

export default {
  name: "Children",
  components: { ProgressCircular, ScheduleCard },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    this.initializePageData();
  },
  methods: {
    ...mapActions({
      fetchChildren: "children/loadChildren",
    }),
    async initializePageData() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.fetchChildren();
      } catch (error) {
        showToast(this, {
          text: `${this.$t(`toastText.errorData`)}: ${error}`,
          status: "error",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    ...mapGetters("children", ["children"]),
  },
};
</script>

<style scoped>
.schedule-list {
  display: flex;
  justify-content: center;
}
</style>
